import React, { useEffect, ReactElement, useRef } from "react";

import { triggerConfetti } from "./confetti-utils";

import type { Options } from "canvas-confetti";

interface ConfettiRevealProps {
  options?: Options;
  show: boolean;
  children: ReactElement<{ id?: string }>;
}

const generateId = () =>
  `confettiReveal-${Date.now().toString(36)}-${Math.random()
    .toString(36)
    .slice(2, 7)}`;

const ConfettiReveal: React.FC<ConfettiRevealProps> = ({
  options,
  show,
  children,
}) => {
  const generatedIdRef = useRef<string | undefined>(undefined);

  const id =
    children.props.id ||
    (() => {
      if (!generatedIdRef.current) {
        generatedIdRef.current = generateId();
      }
      return generatedIdRef.current;
    })();

  useEffect(() => {
    if (show) {
      triggerConfetti(id, options);
    }
  }, [show, options, id]);

  if (!show) {
    return null;
  }

  return React.cloneElement(children, {
    id,
  });
};

export default ConfettiReveal;
